export default {
    data: () => ({
        translations: {
            yourSettings: {
                el: "Οι ρυθμίσεις σου:",
                en: "Your Settings:",
                it: "Le tue impostazioni:"
            },
            reward: {
                el: "Η Επιβράβευση:",
                en: "The Reward:",
                it: "La ricompensa:"
            },
            claimedCoupons: {
                el: "Αποκτημένα Κουπόνια",
                en: "Claimed Coupons",
                it: "Coupon Rivendicati"
            },
            doesNotExpire: {
                el: "Δε λήγει",
                en: "Does not expire",
                it: "Non scade"
            },
            couponValidUntil: {
                el: "Έγκυρο εώς",
                en: "Coupon Valid Until",
                it: "Valido Fino A"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            customersFollowing: {
                el: "Πελάτες συμμετέχουν στην επιβράβευσή σου:",
                en: "Customers Following Your Reward:",
                it: "I clienti che seguono la tua ricompensa:"
            },
            claimed: {
                el: "Αποκτήθηκαν",
                en: "Claimed",
                it: "Rivendicato"
            },
            redeemed: {
                el: "Εξαργυρώθηκαν",
                en: "Redeemed",
                it: "Riscattato"
            },
            inProgress: {
                el: "Σε εξέλιξη",
                en: "In Progress",
                it: "In corso"
            },
            user: {
                el: "Χρήστης",
                en: "User",
                it: "Utenti"
            },
            totalVisits: {
                el: "Επισκέψεις",
                en: "Total Visits",
                it: "Visite totali"
            },
            goalStatus: {
                el: "Κατάσταση",
                en: "Goal Status",
                it: "Stato dell'obiettivo"
            },
            noCustomers: {
                el: "Κανένας πελάτης ακόμα",
                en: "No customers are following right now",
                it: "Nessun cliente sta seguendo in questo momento"
            },
            deleteCoupon: {
                el: "",
                en: "Delete Coupon With Transaction",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure?",
                it: ""
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
